import React, { useEffect, useState } from 'react'
import { Grid, Box, Stack, Button } from '@mui/material'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import ScheduledWorkOrder from './ScheduledWorkOrder'
import UnScheduledWorkOrder from './UnScheduledWorkOrder'
import TotalWorkRequest from './TotalWorkRequest'
import CreateWorkOrder from './CreateWorkOrder'
import Assets from './Assets'
import ContractAndLicense from './ContractAndLicense'
import Inventory from './Inventory'
import OntimeAndOverdueChart from './OntimeAndOverdueChart'
import WorkOrderStatus from './WorkOrderStatus'
import OpenClosedChart from './OpenClosedChart'
import ScheduledUnscheduled from './ScheduledUnscheduled'
import { useDispatch, useSelector } from 'react-redux'
import WidgetDrawer from './WidgetDrawer'
import { getAuthToken, getFacilityId, getuserId } from '../../utility/tokenUtility'
import PageLoader from '../commoncomponents/PageLoader'
import axios from 'axios'
import { BemsGraph, FemsGraph, ifacSecurityURL, MasterGraph } from '../../utility/apiURLS'
import AssetsByWorkGroup from './AssetsByWorkGroup'
import DisposedAssets from './DisposedAssets'
import WorkOrderByCategory from './WorkOrderByCategory'
import WorkRequestStatus from './WorkRequestStatus'
import { setIsEdit } from '../../redux/actions/dashboardActions'
import TotalWorkRequestList from './TotalWorkRequestList'
import WorkRequestToWorkOrder from './WorkRequestToWorkOrder'
import TopAssetsByCost from './TopAssetsByCost'
import TopAssetsByWOCount from './TopAssetsByWOCount'
import CreateWorkRequest from './CreateWorkRequest'
import notificationRepository from '../../api/repositories/notificationRepository'
import NewWorkRequest from './NewWorkRequest'
import { useAccess } from '../../AccessContext'
import utilities from '../../utility/utilities'
import Workorderinhousevsoutsource from './Workorderinhousevsoutsource'
import AssetAgeing from './AssetAgeing'
import TotalWorkorderList from './TotalWorkorderList'
import TopDepartmentRequest from './TopDepartmentRequest'
import Wostatuscompletetoauthorize from './Wostatuscompletetoauthorize'
import UnschWorkorderAgeing from './UnschWorkorderAgeing'
import Workorderstatusbyemployee from './Workorderstatusbyemployee'

function DashboardComponent() {
    const widgets = localStorage.getItem('widgets')
    const roleName = localStorage.getItem('roleName')?.trim();  // Fetch roleName once and trim spaces
    const fcmTokenId = localStorage.getItem('fcmToken')?.trim();  // Fetch roleName once and trim spaces
    const userID = getuserId();  // Fetch roleName once and trim spaces

    const accessData = useAccess();
    const { screenAccess, moduleAccess } = accessData;
    const accessWO = utilities.getScreenPermissions(accessData, "ENGT001");
    const accessWR = utilities.getScreenPermissions(accessData, "ENGT010");
    const accessWOWR = screenAccess?.ENGT001 || screenAccess?.ENGT010
    const accessCL = screenAccess?.ENGA008 || screenAccess?.ENGM010
    const accessScreenWO = screenAccess?.ENGT001
    const accessScreenWR = screenAccess?.ENGT010
    const accessAssets = screenAccess?.ENGM014 || screenAccess?.ENGM013

    const [firstArrayString, secondArrayString] = widgets?.split('|');
    const widgetsToShow = firstArrayString?.split(',').map(Number);
    const widgetsOrderToShow = secondArrayString?.split(',').map(Number);

    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState({});
    const [responseFem, setResponseFem] = useState({});
    const [responseBem, setResponseBem] = useState({});
    const [responsefemlicense, setResponsefemlicense] = useState([]);
    const [responseFemdepart, setResponseFemdepart] = useState([]);
    const [responseBemdepart, setResponseBemdepart] = useState([]);
    const [responseFemwoage, setResponseFemwoage] = useState([]);
    const [responseBemwoage, setResponseBemwoage] = useState([]);
    // const [responseFememployee, setResponseFememployee] = useState([]);
    // const [responseBememployee, setResponseBememployee] = useState([]);
    const [selectedWidgets, setSelectedWidgets] = useState(widgetsToShow || []);
    const [widgetsOrder, setWidgetsOrder] = useState(widgetsOrderToShow || [])
    const dispatch = useDispatch();

    useEffect(() => {
        // Conditional to avoid repeated fetch calls if necessary
        if (!response || Object.keys(response).length === 0) {
            fetchData();
            fetchDataDepartment();
            fetchDataWoageing();
            licenseCertificateListcount();
           // fetchDataWoEmployee();
        }
    }, []);

    const handleWidgetSelectionChange = ({ newSelectedWidgets = [], orderedWidgets = [] }) => {
        setSelectedWidgets(newSelectedWidgets);
        setWidgetsOrder(orderedWidgets);
    };
    const isWidgetSelected = (widgetId) => selectedWidgets?.includes(widgetId);

    function mergeObjects(obj1, obj2) {
        const merged = {};

        const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

        for (const key in obj1) {
            if (Object.hasOwnProperty.call(obj1, key)) {
                merged[key] = obj1[key];
            }
        }

        for (const key in obj2) {
            if (Object.hasOwnProperty.call(obj2, key)) {
                const value1 = merged[key];
                const value2 = obj2[key];

                if (typeof value1 === 'number' && typeof value2 === 'number') {
                    merged[key] += value2;
                } else if (typeof value1 === 'function' && typeof value2 === 'function') {
                    merged[key] = [value1, value2];
                } else if (Array.isArray(value1) && Array.isArray(value2)) {
                    merged[key] = [...value1, ...value2];
                } else if (isObject(value1) && isObject(value2)) {
                    merged[key] = mergeObjects(value1, value2);
                } else {
                    merged[key] = value2;
                }
            }
        }

        return merged;
    }

    function transformWorkGroups(data, service) {
        const workGroups = Object.keys(data)
            .filter(key => key.startsWith('workGroup'))
            .reduce((result, key) => {
                const desc = key.replace("workGroup", "").replace('Count', '');
                result[key] = {
                    count: data[key],
                    desc: desc,
                    service: service
                };
                return result;
            }, {});

        return {
            ...data,
            ...workGroups
        };
    }

    const handleSaveChanges = () => {
        setOpenWidgets(false);
        dispatch(setIsEdit('SET_IS_EDIT', false));
        updateWidgets()
    };

    const updateWidgets = async () => {
        const token = getAuthToken("id_token");
        const userId = getuserId("")
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const postData = {
            widgets: `${selectedWidgets.join(',')}|${widgetsOrder.join(',')}`
        }

        const endpoint = `${ifacSecurityURL}/api/GraphUserdetails/GetUserThemeAndWidgetsList/${userId}`
        setLoading(true);
        try {
            await axios({
                method: "put",
                url: endpoint,
                headers: config.headers,
                data: postData,
            }).then((response) => {
                localStorage.setItem('widgets', response?.data?.widgets)
            });
        } catch (error) {
            console.log(error);

        } finally {
            setLoading(false);
        }
    }


    const modifyWorkGroupObject = (workGroupObject, dataArray) => {
        Object.keys(workGroupObject).forEach((key) => {
            if (key.startsWith("workGroup")) {
                const desc = workGroupObject[key].desc;

                const matchedData = dataArray.find((item) => item.wgcode === desc);

                if (matchedData) {
                    workGroupObject[key].desc = `${matchedData.wgcode} - ${matchedData.wgdesc}`;
                }
            }
        });

        return workGroupObject;
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            if (roleName === 'Helpdesk' || roleName === 'FMSExec' || roleName === 'HospitalFM') {

                const res = await notificationRepository.getFcmToken(userID, fcmTokenId);
            }
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const [responseFem, responseBem, workgroupResponseBems, workgroupResponseFems] = await Promise.all([
                axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountByFacilityId/${facilityId}`, config),
                axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountByFacilityId/${facilityId}`, config),
                axios.get(`${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`, config),
                axios.get(`${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`, config)
            ]);

            setResponseBem(modifyWorkGroupObject(transformWorkGroups(responseBem.data, "BEMS"), workgroupResponseBems.data));
            setResponseFem(modifyWorkGroupObject(transformWorkGroups(responseFem.data, "BEMS"), workgroupResponseFems.data));
            setResponse(mergeObjects(
                modifyWorkGroupObject(transformWorkGroups(responseBem.data, "BEMS"), workgroupResponseBems.data),
                modifyWorkGroupObject(transformWorkGroups(responseFem.data, "FEMS"), workgroupResponseFems.data)
            ));

        } catch (error) {
            console.error("Error fetching Employee data:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchDataDepartment = async () => {

        try {

            const token = getAuthToken("id_token");
            const facilityId = getFacilityId();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const [responseFemdepart, responseBemdepart] = await Promise.all([
                axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountDepartment/${facilityId}`, config),
                axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountDepartment/${facilityId}`, config),

            ]);

            setResponseBemdepart(responseBemdepart.data);
            setResponseFemdepart(responseFemdepart.data);
            // setResponse(mergeObjects(
            //     modifyWorkGroupObject(transformWorkGroups(responseBemdepart.data, "BEMS")),
            //     modifyWorkGroupObject(transformWorkGroups(responseFemdepart.data, "FEMS"))
            // ));

        } catch (error) {
            console.error("Error fetching Employee data:", error);
        } finally {

        }
    };


      const fetchDataWoageing = async () => {

        try {

            const year = new Date().getFullYear();
            const month = new Date().getMonth() + 1; // Months are 0-indexed in JavaScript
            
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const [responseFemwoage, responseBemwoage] = await Promise.all([
                axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month}/${year}/1`, config),
                axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month}/${year}/1`, config),
              
            ]);

            setResponseBemwoage(responseBemwoage.data);
            setResponseFemwoage(responseFemwoage.data);
          
         
        } catch (error) {
            console.error("Error fetching Employee data:", error);
        } finally {
          
        }
    };

  const licenseCertificateListcount = async (activeTab) => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${MasterGraph}/api/graph/GetDashboardcountLicenseLists/${facilityId}`, config);

        setResponsefemlicense(response?.data[0]);
    }
    catch (error) {
        console.log(error);
    }
};

    const [openWidgets, setOpenWidgets] = React.useState(false);
    const isEdit = useSelector(state => state.dashboard.isEdit);

    return (
        <>
            <PageLoader open={loading} />
            {isEdit && (
                <Stack direction={'row'} width={'40%'} alignItems={'center'} gap={2}>
                    <Button variant='contained' onClick={handleSaveChanges}>Save Changes</Button>
                    <Button variant='outlined' onClick={() => setOpenWidgets(true)}>Add / Remove Widgets</Button>
                </Stack>
            )}
            <Box mt={2}>
                <Grid container spacing={2}>
                    {accessWOWR && <>{isWidgetSelected(1) && (
                        <Grid item xs={6} md={2}>
                            <ScheduledWorkOrder response={response} />
                        </Grid>
                    )}
                        {isWidgetSelected(2) && (
                            <Grid item xs={6} md={2}>
                                <UnScheduledWorkOrder response={response} />
                            </Grid>
                        )}
                        {isWidgetSelected(3) && (
                            !accessWO?.canClose && <Grid item xs={6} md={2}>
                                <TotalWorkRequest response={response} />
                            </Grid>
                        )}
                        {isWidgetSelected(4) && (
                            !accessWO?.canClose && <Grid item xs={6} md={2}>
                                <NewWorkRequest />
                            </Grid>
                        )}
                    </>}
                    {isWidgetSelected(5) && accessWO?.canCreate && (
                        <Grid item xs={6} md={2}>
                            <CreateWorkOrder />
                        </Grid>
                    )}
                    {isWidgetSelected(6) && accessWR?.canCreate && (
                        <Grid item xs={6} md={2}>
                            <CreateWorkRequest />
                        </Grid>
                    )}
                </Grid>
                <Box my={2}>
                    <ResponsiveMasonry>
                        <Masonry gutter="16px">
                            {widgetsOrder.map((widgetId) => {
                                if (!isWidgetSelected(widgetId)) return null;

                                switch (widgetId) {
                                    case 7:
                                        return accessAssets && <Assets key={6} responseFem={responseFem} responseBem={responseBem} />;
                                    case 8:
                                        return accessCL && <ContractAndLicense key={7} response={response} responsefemlicense={responsefemlicense} />;
                                    case 9:
                                        return accessScreenWO && <WorkOrderStatus key={8} response={response} />;
                                    case 10:
                                        return accessScreenWR && <AssetsByWorkGroup key={9} response={response} />;
                                    case 11:
                                        // return accessAssets && <DisposedAssets key={10} response={response} />;
                                        return accessAssets && <Workorderstatusbyemployee key={10} />;
                                    case 12:
                                        // return moduleAccess?.inventory && <Inventory key={11} response={responseFem} />;
                                        return accessScreenWO && <Workorderinhousevsoutsource key={11} />;
                                    case 13:
                                        // return accessScreenWO && <WorkOrderByCategory key={12} response={response} />;
                                        return accessScreenWO && <UnschWorkorderAgeing key={12} responseFemwoage={responseFemwoage} responseBemwoage={responseBemwoage} />;
                                    case 14:
                                        // return accessScreenWR && <WorkRequestStatus key={13} response={response} />;
                                        return accessAssets && <TopDepartmentRequest key={13} responseFemdepart={responseFemdepart} responseBemdepart={responseBemdepart} />;
                                    case 15:
                                        // return accessScreenWO && <OntimeAndOverdueChart key={14} response={response} />;
                                        return accessScreenWO && <AssetAgeing key={14} responseFem={responseFem} responseBem={responseBem} />;
                                    case 16:
                                        return accessScreenWO && <OpenClosedChart key={15} response={response} />;
                                    case 17:
                                        return accessScreenWO && <ScheduledUnscheduled key={16} response={response} />;
                                    case 18:
                                        // return accessScreenWR && <TotalWorkRequestList key={17} responseFem={responseFem} responseBem={responseBem} />;
                                        return accessScreenWR && <TotalWorkorderList key={17} responseFem={responseFem} responseBem={responseBem} />;
                                    case 19:
                                        return accessScreenWR && <WorkRequestToWorkOrder key={18} />;
                                    // case 20:
                                    //     return accessAssets && <TopAssetsByWOCount key={19} responseFem={responseFem} responseBem={responseBem} />;
                                    // case 21:
                                    //     return accessAssets && <TopAssetsByCost key={20} responseFem={responseFem} responseBem={responseBem} />;
                                    case 22:
                                        return accessScreenWO && <Wostatuscompletetoauthorize key={21} response={response} />;
                                    default:
                                        return null;
                                }
                            })}
                        </Masonry>
                    </ResponsiveMasonry>
                </Box>
            </Box>
            <WidgetDrawer
                open={openWidgets}
                onClose={() => setOpenWidgets(false)}
                selectedWidgets={selectedWidgets}
                onChange={handleWidgetSelectionChange}
                widgetsOrder={widgetsOrder}
            />
        </>
    )
}

export default DashboardComponent;
